<template>
    <div class="group-form__block select-staffs">
        <div class="select-staffs-wraper">
            <div class="staffs-diaplay">
                <div
                    v-for="(staff, sIndex) in staffOrgList"
                    :key="sIndex"
                    class="staffs-diaplay__item"
                >
                    <v-icon
                        v-if="staff.name"
                        name="department"
                    />
                    <span
                        v-if="staff.name"
                        class="staffs-diaplay__staff"
                    >{{ staff.name }}<v-icon
                        class="delete-staff"
                        name="circle-delete"
                        @click="deleteStaffDepart(sIndex)"
                    /></span><span>{{ getCommaText(sIndex, staffOrgList) }}</span>
                </div>
                <div
                    v-for="(staff, sIndex) in staffSelected"
                    :key="sIndex"
                    class="staffs-diaplay__item"
                >
                    <v-icon
                        v-if="staff.gender == 1 && staff.name"
                        name="male"
                    />
                    <v-icon
                        v-if="staff.gender != 1 && staff.name"
                        name="female"
                    />
                    <span
                        v-if="staff.name"
                        class="staffs-diaplay__staff"
                    >{{ staff.name
                    }}<v-icon
                        class="delete-staff"
                        name="circle-delete"
                        @click="deleteStaff(sIndex)"
                    /></span><span>{{ getCommaText(sIndex, staffSelected) }}</span>
                </div>
            </div>
            <staff-select
                :prop-staff-selected="staffSelected"
                :delete-ids="deleteIds"
                :staff-selected-err="staffSelectedErr"
                :prop-staff-org-list="propStaffOrgList"
                @change="staffSelectedChange"
                @select="showSelect"
                @changeSelected="changeSelected"
            />
        </div>
        <!-- <div
            v-if="staffOrgList.length || staffSelected.length"
            class="staffs-total"
        >
            共<span>{{ `${staffOrgList.length > 0 ? staffOrgList.length + '部门' : ''}` }}</span>
            <span>{{ `${staffSelected.length ? staffSelected.length + '人' : ''}` }}</span>
        </div> -->
    </div>
</template>

<script>
/* eslint-disable */

import { Icon } from 'vhtml-ui';
import staffSelect from '../staff-select';

const req = require.context('../../assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);

export default {
    name: 'SelectStaffs',
    components: {
        staffSelect
    },
    props: {
        propStaffSelected: {
            type: Array,
            default() {
                return [];
            }
        },
        staffSelectedErr: {
            type: Boolean,
            default() {
                return false;
            }
        },
        propStaffOrgList: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        const staffSelected = [];
        this.propStaffSelected.forEach(staff => {
            staffSelected.push({
                id: staff.id,
                name: staff.name,
                ename: staff.ename,
                gender: staff.gender
            });
        });
        const staffOrgList = [];
        this.propStaffOrgList.forEach(staff => {
            staffOrgList.push({
                id: staff.id,
                name: staff.name,
                isFolder: true,
                total: staff.total
            });
        });
        /**
         * doDelete用来记录外部组件删除staff的行为，用来通知staff-select内部进行数据更新与变化
         */
        return {
            staffSelected,
            deleteIds: [],
            staffOrgList
            //   doDelete: 0
        };
    },
    computed: {},
    methods: {
        changeSelected() {
             console.log('改变');
            this.$emit('changeSelected',false);
        },
        staffSelectedChange(staffSelected) {
            console.log('staffSelectedChange');
            this.staffSelected = staffSelected;
            this.$emit('change', staffSelected);
        },
        getCommaText(index, arr) {
            // return index < arr.length - 1 ? '' : '';
        },
        deleteStaff(sIndex) {
            this.deleteIds = [this.staffSelected[sIndex].id];
            this.staffSelected.splice(sIndex, 1);
            this.$emit('change', this.staffSelected);
        },
        deleteStaffDepart(sIndex) {
            this.deleteIds = [this.staffOrgList[sIndex].id];
            this.staffOrgList.splice(sIndex, 1);
            this.$emit('changeOrg', this.staffOrgList);
        },
        showSelect(res) {
            let userList = [];
            let depart = [];
            let totalList={
                user:[],
                depart:[]
            };
            let arr=[];
             let staffList = res.map(item=>{
                 if(!item.isFolder) {
                     userList.push(item)
                     return userList
                 }
             })
                     console.log(userList,'员工')
             let staffOrgList = res.map(item=>{
                  if(item.isFolder==true) {
                     depart.push(item)
                     return depart
                 }
             })
             totalList.user=userList;
             totalList.depart=depart;
             console.log('我是拼接的数组',totalList);
                     console.log(depart,'部门')

            console.log(res);
            // if (this.staffSelected.length != 0) {
            //     this.staffSelected = this.staffSelected.concat(userList);
            // } else {
            // }
            // arr=this.staffSelected.filter((item,index)=>{
            //     return item.name!=item.name
            // })
               this.staffSelected = userList;
               this.staffOrgList=depart

            // if(this.staffOrgList.length!=0){
            // this.staffOrgList=this.staffOrgList.concat(depart)
            // }else {
            // }
            this.$emit('select', this.staffSelected);
            this.$emit('selectDepart',this.staffOrgList)
        }
    }
};
</script>

<style lang="less">
@import '~@/common/common';
.select-staffs-wraper {
    display: flex;
    align-items: center;
}

.select-staffs {
    .staffs-total {
        margin-top: 5px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        color: #a8abb3;
    }

    .staffs-diaplay {
        overflow: visible;
        max-height: 210px;
        // margin-bottom: 5px;
        // overflow: visible;
        // &__item:not(:first-child){
        //      margin-left: 10px;
        // }
        &__item {
            display: inline-block;
            // margin-top: 10px;
            //   float: left;
            margin-right: 10px;
            padding-left: 10px;
            background: #fff;
            border: 1px solid #dadee7;
            border-radius: 2px;
            cursor: default;

            > span {
                display: inline-block;
            }

            &:hover {
                background-color: #fff;
                border-radius: 1px;
                box-shadow: 0 0 10px #c8cbd3;

                .delete-staff {
                    display: inline-block;
                    color: #c8cbd3;
                    background-color: #adb2be;

                    &:hover {
                        color: red;
                        cursor: pointer;
                    }
                }
            }
        }

        &__staff {
            position: relative;
            padding: 0 5px;
            line-height: 24px;

            .delete-staff {
                position: absolute;
                top: -6px;
                right: -6px;
                display: none;
                width: 13px;
                height: 13px;
                border-radius: 50%;
                z-index: 100;
            }
        }
    }
}
</style>
